import { Observable, ReplaySubject } from 'rxjs';
import { TableFilterService } from '../../services/table-filter/table-filter.service';
import { SortOrder } from '../../services/table-sort/table-sort.interface';
import { TableSortService } from '../../services/table-sort/table-sort.service';
import { FilterTypes } from './filter.interface';

export class FilterTableHeaderComponent<T, G, E> {
    public name?: string;
    public filterProperty?: keyof T & string;
    public tagPosition?: number;

    public filterValue?: Observable<string>;
    public sortOrderObs?: Observable<string>;
    public sortOrderInput: ReplaySubject<SortOrder> = new ReplaySubject(1);
    protected order?: SortOrder;

    public constructor(
        public filterService: TableFilterService<T, G, E>,
        public sortService: TableSortService<T, G, E>
    ) {}

    public updateFilter(value: any, filterType: FilterTypes = FilterTypes.TEXT_FILTER): void {
        if (!this.name || !this.filterProperty || this.tagPosition === undefined) {
            return console.warn(
                'Trying to set/update a text filter without name, filterProperty or tagPosition'
            );
        }

        switch (filterType) {
            case FilterTypes.TEXT_FILTER:
                this.filterService.setTextFilter(
                    this.filterProperty,
                    this.name,
                    value,
                    this.tagPosition,
                    false
                );
                break;
            case FilterTypes.BOOLEAN_FILTER:
                value = typeof value === 'string' ? value === 'true' : value;
                this.filterService.setBoolFilter(this.filterProperty, this.name, value, this.tagPosition);
                break;
            case FilterTypes.TEXT_EQUAL_FILTER:
                this.filterService.setTextFilter(
                    this.filterProperty,
                    this.name,
                    value,
                    this.tagPosition,
                    true
                );
                break;
            default:
                const exhaustiveCheck: never = filterType;
                throw new Error(`Unknown filter type: ${exhaustiveCheck}`);
        }
    }

    public updateSorting(sortOrder: SortOrder) {
        if (!sortOrder) {
            return;
        }

        if (!this.filterProperty) {
            return console.warn('Trying to set/update a text sorter without filterProperty');
        }

        this.sortService.setTextSorter(this.filterProperty, sortOrder);
    }
}
